import { Component, HostListener, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { candidatesGet } from '@collections/candidates';
import { hasAnonymization } from '@collections/users';
import { CandidateAdapter } from '@shared/models';
import { AppFeatureExtensions } from '@app/app-feature-extensions.config';

@Component({
  selector: 'mojo-candidate-resume-preview-link',
  templateUrl: './candidate-resume-preview-link.component.html',
  styleUrls: ['./candidate-resume-preview-link.component.scss'],
})
export class CandidateResumePreviewLinkComponent {
  @Input() candidate: CandidateAdapter;
  @Input() linkText = 'Resume';
  @Input() icon = true;
  @Input() fromNotes = false;
  @Input() iconEnlarge = false;

  coverLetterFE = AppFeatureExtensions.DISPLAY_COVER_LETTER_FILES;

  @HostListener('mouseenter')
  onMouseEnter() {
    const hasAnonymization$ = this.store.select(hasAnonymization).pipe(take(1));
    this.subs.add(
      hasAnonymization$.subscribe((anonymization) => {
        if (anonymization) {
          this.store.dispatch(candidatesGet({ id: this.candidate.id }));
        }
      }),
    );
  }
  subs = new Subscription();

  constructor(private store: Store<{}>) {}
}
